import axios from "axios";
import { resolvePlayitApiUrl } from "./playitApiConfig";

export function setupPlayitApiInterceptor() {
  axios.interceptors.request.use((config) => {
    if (config.url) {
      config.url = resolvePlayitApiUrl(config.url);
    }

    if (config.baseURL) {
      config.baseURL = resolvePlayitApiUrl(config.baseURL);
    }

    return config;
  });
}
